import React from "react";
import  "./styles/DropdownArrow.scss";


interface Props {
    className: string;
    showDropdown: boolean;
    marginLeft?: string;
}

const DropdownArrow = (props: Props) => {

    if(props.showDropdown) {
        return <span className={"arrow-icon"}><span className="material-icons">arrow_drop_up</span></span>
    }

    return (
       <span className={"arrow-icon"}><span className="material-icons">arrow_drop_down</span></span>
    )

}

export default DropdownArrow;
